import { Tooltip } from 'antd';
import { CloudFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface LaggingBubbleProps {
  projectId: number;
  projectName: string;
  requirementId: string;
  subcategory: string;
  /** Whether this requirement currently lags behind mainline. */
  lagging: boolean;
}

/**
 * Yellow cloud shown next to a requirement id when the project requirement
 * lags behind its mainline counterpart. Click → jump to the 需求同步 page
 * with source=mainLine (the requirement pre-selected) and target=this project,
 * mirroring the 需求回流 "评审" entry but in the reversed direction.
 */
const LaggingBubble: React.FC<LaggingBubbleProps> = ({
  projectId,
  projectName,
  requirementId,
  subcategory,
  lagging,
}) => {
  const navigate = useNavigate();

  if (!lagging) return null;

  const go = () => {
    const sp = new URLSearchParams({
      srcProject: 'mainLine',
      srcSubcatagory: subcategory,
      desProject: projectName,
      desSubcatagory: subcategory,
      requirementId,
      laggingProjectId: String(projectId),
    });
    navigate(`/requirement-sync?${sp.toString()}`);
  };

  return (
    <Tooltip title="项目需求落后于主线，点击处理">
      <span
        onClick={(e) => {
          e.stopPropagation();
          go();
        }}
        style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
      >
        <CloudFilled style={{ color: '#d48806', fontSize: 16 }} />
      </span>
    </Tooltip>
  );
};

export default LaggingBubble;
